/*-------------------------------------------

slickの設定

-------------------------------------------*/
$(function() {
    if (window.matchMedia( '(max-width: 480px)' ).matches){
        $('.slider').slick({

            // 矢印ボタンを画像に置き換え
            prevArrow: '<img src="/images/lp/001/prevArrow.svg" class="prevArrow">',
            nextArrow: '<img src="/images/lp/001/nextArrow.svg" class="nextArrow">',

            // ドットを表示+class付与
            dotsClass: 'original-dots',
            dots: true,
        });
    };
});